import { token } from '@styled-system/tokens';
import { PuffLoader } from 'react-spinners';

interface SpinnerProps {
  size?: number;
  color?: string;
  className?: string;
}

export const Spinner = ({ size = 24, color, className }: SpinnerProps) => {
  const resolvedColor = color ?? token.var('colors.brand.primary');
  return <PuffLoader size={size} color={resolvedColor} className={className} />;
};
